var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeLeadDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33876 5.72498H4.08071C4.192 5.72498 4.26619 5.65079 4.26619 5.5395V4.98304H6.86301V5.5395C6.86301 5.65079 6.9372 5.72498 7.04849 5.72498H7.79044C7.90173 5.72498 7.97592 5.65079 7.97592 5.5395V4.98304C7.97592 4.37093 7.47511 3.87012 6.86301 3.87012H4.26619C3.65409 3.87012 3.15327 4.37093 3.15327 4.98304V5.5395C3.15327 5.65079 3.22747 5.72498 3.33876 5.72498Z",
    fill: "#0D2045"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0163 6.8379H1.11292C0.500814 6.8379 0 7.33872 0 7.95082V13.8864C0 14.4985 0.500814 14.9993 1.11292 14.9993H10.0163C10.6284 14.9993 11.1292 14.4985 11.1292 13.8864V7.95082C11.1292 7.33872 10.6284 6.8379 10.0163 6.8379Z",
    fill: "#0D2045"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84905 1.69357H10.5265C10.6281 1.69357 10.6958 1.62583 10.6958 1.52422V1.01614H13.0668V1.52422C13.0668 1.62583 13.1346 1.69357 13.2362 1.69357H13.9136C14.0152 1.69357 14.083 1.62583 14.083 1.52422V1.01614C14.083 0.457265 13.6257 0 13.0668 0H10.6958C10.137 0 9.67969 0.457265 9.67969 1.01614V1.52422C9.67969 1.62583 9.74743 1.69357 9.84905 1.69357ZM10.1874 2.70972V5.24951H11.7122C12.2711 5.24951 12.7283 5.70678 12.7283 6.26566V10.1614H15.9459C16.5048 10.1614 16.9621 9.70418 16.9621 9.1453V3.72586C16.9621 3.16698 16.5048 2.70972 15.9459 2.70972H10.1874Z",
    fill: "#0D2045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeLeadDuplicate);
export default __webpack_public_path__ + "static/media/nodeLeadDuplicate.dcd796d8e7ed94256972ce3b1443a912.svg";
export { ForwardRef as ReactComponent };